<script>
import { mapActions, mapState } from 'vuex'
import { config } from '@/config'
// import addFile from '@/components/addFile'

export default {
  async created () {
    await this.reload()
  },
  data () {
    return {
      titulo: 'Nova Imagem',
      url: config.API_URL,
      filtros: {},
      form: {},
      file: null
    }
  },
  computed: {
    ...mapState({
      list: state => state.arquivo.list,
      page: state => state.arquivo.filtros.page,
      lastPage: state => state.arquivo.lastPage
    }),
    paginate () {
      let result = {
        dots_prev: false,
        firstPage: 1,
        page: parseInt(this.page),
        list: [],
        lastPage: parseInt(this.lastPage),
        dots_next: false
      }
      // Cria lista que ira exibir
      let comeca = -2
      let termina = 2
      if (result.page === result.firstPage) {
        comeca = 0
        termina = 4
      } else if (result.page - 1 === result.firstPage) {
        comeca = -1
        termina = 3
      } else if (result.page + 1 === result.lastPage) {
        comeca = -3
        termina = 1
      } else if (result.page === result.lastPage) {
        comeca = -4
        termina = 0
      }
      for (let x = comeca; x <= termina; x++) {
        let p = result.page + x
        if (p >= result.firstPage && p <= result.lastPage) result.list.push(p)
      }
      // Pega primeiro e ultimo item da lista
      let primeiroItem = result.list[0]
      // Valida Prev Next e Dots
      if (primeiroItem > result.firstPage) result.dots_prev = true
      if (result.page !== result.lastPage) result.next = true
      return result
    }
  },
  methods: {
    ...mapActions({
      remove: 'arquivo/remove',
      getList: 'arquivo/list',
      add: 'arquivo/add',
      get: 'arquivo/get',
      change: 'arquivo/edit'
    }),
    async reload () {
      await this.getList(this.filtros)
    },
    goToPage (page) {
      this.filtros.page = page
      this.getList(this.filtros)
    },
    async edita (item) {
      let form = await this.get(item.id)
      this.titulo = `Edita Imagem `
      let { id, alt } = form
      this.form = { id, alt }
    },
    async exclui (item) {
      if (confirm('Deseja mesmo excluir essa imagem?')) {
        try {
          await this.remove(item.id)
          await this.reload()
        } catch (e) {
          if (e.response) {
            alert(e.response.data.message)
          } else alert(e.message)
        }
      }
    },
    async novo () {

    },
    async salva () {
      try {
        if (!this.form.id) {
          let data = new FormData()
          data.append('file', this.$refs.ImagemFile.files[0])
          data.append('alt', this.form.alt)
          await this.add(data)
        } else {
          await this.change(this.form)
        }
        await this.reload()
        this.cancela()
      } catch (e) {
        if (e.response) {
          alert(e.response.data.message)
        } else alert(e.message)
      }
    },
    async cancela () {
      this.titulo = 'Nova Imagem'
      this.form = {}
    }
  }

}
</script>

<template>
  <div class="crud">
    <div class="columns">
      <div class="column">
        <div class="card">
          <div class="card-content">
            <h4>Todas os imagens</h4>
            <form @submit.prevent="getList(filtros)">
              <div class="field is-horizontal filtros">
                <div class="field-body">
                  <div class="field">
                    <p class="control is-expanded">
                      <input class="input" type="text" placeholder="Digite o nome" v-model="filtros.nome">
                    </p>
                  </div>
                  <div class="field is-grouped">
                    <div class="control is-expanded">
                      <button class="button is-link is-info" type="submit"><i class="fa fa-search"></i></button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
            <div class="list-files">
              <div class="item-files" v-for="(item, indice) in list" :key="indice">
                <div class="card card-arquivo">
                  <div class="card-content">
                    <div class="media">
                      <div class="media-left">
                        <figure class="image">
                          <img :src="`${url}arquivo/view/${encodeURIComponent(item.nome)}${item.extensao}`">
                        </figure>
                      </div>
                    </div>
                    <p class="title">{{ item.nome }}{{item.extensao}}</p>
                    <button class="button is-small is-warning" @click="edita(item)">editar</button>
                    <button class="button is-small is-danger" @click="exclui(item)">excluir</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="clear-both"></div>
            <nav class="pagination">
              <ul class="pagination-list">
                <li v-if="paginate.dots_prev"><a class="pagination-link" @click="goToPage(paginate.firstPage)">{{ paginate.firstPage }}</a></li>
                <li v-if="paginate.dots_prev"><span class="pagination-ellipsis">&hellip;</span></li>
                <li v-for="(item, indice) in paginate.list" :key="indice">
                  <a class="pagination-link" @click="goToPage(item)" :class="{ 'is-current': item === paginate.page }">{{ item }}</a>
                </li>
                <li v-if="paginate.dots_next"><span class="pagination-ellipsis">&hellip;</span></li>
                <li v-if="paginate.dots_next"><a class="pagination-link" @click="goToPage(paginate.lastPage)">{{ paginate.lastPage }}</a></li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="column">
        <div class="card">
          <div class="card-content">
            <h4>{{ titulo }}</h4>
            <form @submit.prevent="salva">
              <div class="field" v-if="!form.id">
                  <div class="control is-expanded">
                      <input type="file" ref="ImagemFile" placeholder="Imagem"/>
                  </div>
              </div>
              <div class="field">
                <label class="label">Alt</label>
                <div class="control">
                  <input class="input" type="text" placeholder="Digite o alt da imagem" v-model="form.alt">
                </div>
              </div>
              <div class="field is-grouped mt-10">
                <div class="control">
                  <button class="button is-link is-success" type="submit">Salvar</button>
                </div>
                <div class="control">
                  <button class="button is-text" type="button" @click="cancela">Cancelar</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style>
  .mt-10 {
    margin-top: 10px;
  }
  .crud {
    width: 100%;
    text-align: left;
    margin:10px;
  }
  .crud .table {
    margin: 0px;
    margin-top: 15px;
  }
  .crud .table tr {
    height: 30px;
  }
  .crud .table thead th {
    font-weight: bold;
  }
  .crud .table thead th, .crud .table tbody td {
    padding: 5px !important;
  }
  .crud .table tbody td.actions {
    text-align: center
  }
  .crud .table tbody td.actions button {
    margin-right: 5px;
  }
  .pagination .pagination-list {
    margin: 0px
  }
  .pagination .pagination-list li {
    list-style: none;
  }
  .control input, .control select {
    border: 1px solid #dbdbdb;
  }
  .list-files {
    margin-top: 15px;
    width: 100%;
  }
  .item-files {
    width: 45%;
    float: left;
    margin: 5px;
  }
  .clear-both {
    clear: both;
    margin-bottom: 10px;
  }
  .card-arquivo .card-content {
    padding: 10px;
  }
  .card-arquivo .media-left {
    width: 100%;
  }
  .card-arquivo .media-left figure.image {
    width: 100%;
    margin: auto;
  }
  .card-arquivo .media-left figure.image img {
    text-align: center;
    width: auto;
    margin: auto;
    height: 80px;
  }
  .card-arquivo .media-content {
    display: block;
    float: none;
    width: 100%;
  }
  .card-arquivo .card-content p.title {
    font-size: 14px !important;
  }
  .card-arquivo .card-content button {
    margin-top: 5px;
  }
</style>
